import { useCallback } from 'react';
import { ICalculatorMcfValues, TCalculatorAnalytics, TCalculatorMcfErrorsItem } from '../../../types/features';
import {
  resetCalculatorErrors,
  resetCalculatorValues,
  setCalculatorErrors,
  setCalculatorValues,
} from '../../../redux/landingSlice';
import { useDispatch } from 'react-redux';
import { debounce } from '@cian/ui-kit/internal/utils';
import { useTracking } from '../../../utils/tracking/useTracking';

export const useCalculatorHandlers = () => {
  const dispatch = useDispatch();
  const { trackEditFormValues, trackClickOnMoreFilters } = useTracking();

  const debouncedCalculationTracking = debounce(
    (eventData: ICalculatorMcfValues) => trackEditFormValues(eventData),
    300,
  );

  const onSubmitCalculator = useCallback(
    async (e: CustomEvent<{ data: ICalculatorMcfValues }>) => {
      dispatch(
        setCalculatorValues({
          ...e.detail.data,
        }),
      );

      dispatch(resetCalculatorErrors());
      debouncedCalculationTracking(e.detail.data);
    },
    [dispatch],
  );

  const onCatchErrorCalculator = useCallback(
    (e: CustomEvent<{ data: TCalculatorMcfErrorsItem[] }>) => {
      dispatch(setCalculatorErrors(e.detail.data));
      dispatch(resetCalculatorValues());
    },
    [dispatch],
  );

  const onSendAnalyticsCalculatorEvent = useCallback((e: CustomEvent<{ data: TCalculatorAnalytics }>) => {
    const { eventName } = e.detail.data;

    if (eventName === 'onClickMoreFilters') {
      trackClickOnMoreFilters();
    }
  }, []);

  return {
    onSubmitCalculator,
    onCatchErrorCalculator,
    onSendAnalyticsCalculatorEvent,
  };
};
